<app-navbar [hide_menu]="true" [show_cart]="true"></app-navbar>

<div class="checkout-wrapper" [class.active]="!!alacarte_session?.cart.items.length">
  <div class="container">

    <div class="empty-cart" *ngIf="!alacarte_session?.cart.items.length; else cartNotEmpty">
      <img loading="lazy" src="assets/products/empty-cart.png" alt="Cart is empty">
      <h4 class="mt-3">Your Cart is Empty!</h4>
      <p class="mt-n2">We see your cart is a bit shy. Let's fill it with some goodies!</p>
    </div>

    <ng-template #cartNotEmpty>
      <ng-container *ngIf="checkout_form" [formGroup]="checkout_form">
        <div class="row" [class.processing]="processing">
          <div class="col-lg-12">
            <div class="header">
              <h1 class="text-center">Cart</h1>
              <div class="go-back">
                <a (click)="functionsService.goBack(location)">
                  <i class="bi bi-arrow-left bi-xl"></i>
                </a>
                <a (click)="functionsService.goBack(location)">
                  Continue shopping
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="contents">

              <ng-container *ngIf="checkout_form.get('amount_to_pay').value <= 0; else notFree">
                <div class="text-center py-4">
                  <img loading="lazy" src="assets/success-illustration.png" width="60%">
                  <p class="mt-4 text-success mb-0">Free purchase!</p>
                </div>
              </ng-container>

              <ng-template #notFree>

                <div class="cart">
                  <div class="cart-item"
                    *ngFor="let item of checkout_form.controls.cart.controls.items.controls; let index = index">
                    <div class="cart-product-description">
                      <img loading="lazy" src="assets/qr.png" width="50" height="50" alt="QR Icon">
                      <div class="desc">
                        <label><small>Description</small></label>
                        <a [href]="item.controls.product_url.value"
                          class="title">{{item.controls.product_title.value}}</a>
                        <div class="description">
                          <small>{{item.controls.product_description.value}}</small>
                        </div>
                        <small>
                          <b>{{item.controls.unit_price.value | currency:
                            alacarte_session.currency}}</b>
                        </small>
                      </div>
                    </div>

                    <div class="quantity-control">
                      <label><small>Quantity</small></label>
                      <div class="item-to-cart">
                        <button [disabled]="item.controls.quantity.value <= 1"
                          (click)="updateCartItemQuantity(item, index, false)"><i class="bi bi-dash"></i></button>
                        <strong>{{item.controls.quantity.value}}</strong>
                        <button [disabled]="item.controls.quantity.value >= 100"
                          (click)="updateCartItemQuantity(item, index)"><i class="bi bi-plus"></i></button>
                      </div>
                      <p><small class="remove" (click)="removeCartItem(index)">x remove</small>
                      </p>
                    </div>

                    <div>
                      <label><small>Total</small></label>
                      <div>
                        <b>{{(item.controls.unit_price.value * item.controls.quantity.value) |
                          currency:
                          alacarte_session.currency}}</b>
                      </div>
                    </div>

                  </div>
                </div>

                <ng-container formGroupName="cart">
                  <h5 class="my-3">Email Address<i class="bi bi-info-circle-fill small ms-2"
                      title="An email will be sent to this address with the QR Code and activation instruction."
                      data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="top"></i>
                  </h5>
                  <div class="row g-3">
                    <div class="col-sm-12">
                      <input type="email"
                        [class.is-invalid]="(checkout_form.get('cart.email').hasError('required') || checkout_form.get('cart.email').hasError('cart.email')) && checkout_form.get('cart.email').touched"
                        formControlName="email" required class="form-control" placeholder="Email">
                      <ng-container *ngIf="checkout_form.get('cart.email').touched">
                        <p class="input-error" *ngIf="checkout_form.get('cart.email').hasError('required')">
                          Email is required!
                        </p>
                        <p class="input-error" *ngIf="checkout_form.get('cart.email').hasError('email')">
                          Email is invalid!
                        </p>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>

                <ng-container formGroupName="billing_address">
                  <h5 class="mt-5 mb-3">Billing Information
                    <i class="bi bi-chevron-right bi-sm mx-1"></i>
                    <span class="text-muted">{{checkout_form.get("billing_address.full_name").value}}</span>
                  </h5>
                  <app-shared-billing-address-form
                    [data]="checkout_form.controls.billing_address"></app-shared-billing-address-form>
                </ng-container>
              </ng-template>

            </div>
          </div>
          <div class="col-lg-5 mt-5 mt-lg-0">
            <div class="contents">

              <h5>Order Summary</h5>
              <div class="order-details mt-3" *ngFor="let item of checkout_form.controls.cart.controls.items.value">
                <b>{{item.product_title}}
                  <div>
                    <small>{{item.product_description}} <b>(x{{item.quantity}})</b></small>
                  </div>
                </b>
                <b>{{(item.unit_price * item.quantity) | currency:
                  checkout_form.get('currency').value}}</b>
              </div>

              <div class="order-details mt-3"
                *ngIf="checkout_form.get('coupons.discount.valid').value && checkout_form.get('coupons.discount.actual_value_off').value > 0">
                <b>Discount</b>
                <b class="text-success">- {{checkout_form.get('coupons.discount.actual_value_off').value
                  |
                  currency:
                  checkout_form.get('currency').value}}</b>
              </div>

              <div class="order-details mt-3" *ngIf="checkout_form.get('tax').value > 0">
                <b>Tax</b>
                <b>{{checkout_form.get('tax').value | currency:
                  checkout_form.get('currency').value}}</b>
              </div>
              <div class="total-wrapper">
                <h6>Total</h6>
                <h5 class="total">
                  {{checkout_form.get('amount_to_pay').value | currency:
                  checkout_form.get('currency').value}}
                </h5>
              </div>

              <div class="code-wrapper my-4"
                *ngIf="checkout_form.get('coupons.discount.valid').value; else discountNotSet">
                <div class="code">
                  {{checkout_form.get('coupons.discount.code').value}}
                </div>
                <div class="close">
                  <i class="bi bi-x" (click)="resetCoupon()"></i>
                </div>
              </div>
              <ng-template #discountNotSet>
                <div class="accordion accordion-wrapper v2 my-4">
                  <div class="accordion-item">
                    <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#discount-code" aria-expanded="false" aria-controls="discount-code">
                        <b>I have a discount code</b>
                      </button>
                    </h2>
                    <div id="discount-code" class="accordion-collapse collapse" aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample">
                      <div class="accordion-body pt-3">
                        <form [formGroup]="discount_form" class="animated fadeIn" [class.processing]="applying_discount"
                          (ngSubmit)="applyCoupon()">
                          <div class="input-group">
                            <input type="text" required maxlength="35" formControlName="code"
                              [class.is-invalid]="discount_form.get('code').hasError('required') && discount_form.get('code').touched"
                              class="form-control text-uppercase" placeholder="Discount Code">
                            <button class="btn btn-secondary" type="submit">
                              <app-inline-loader *ngIf="applying_discount" class="no-margin">
                              </app-inline-loader>
                              <span *ngIf="!applying_discount">Apply</span>
                            </button>
                          </div>
                        </form>
                        <p class="input-error"
                          *ngIf="discount_form.get('code').hasError('required') && discount_form.get('code').touched; else noInputError">
                          <i class="bi bi-x-circle me-1"></i>
                          Discount code is required!
                        </p>
                        <ng-template #noInputError>
                          <p class="input-error"
                            *ngIf="checkout_form.get('coupons.discount.why').value && !checkout_form.get('coupons.discount.valid').value">
                            <i class="bi bi-x-circle me-1"></i>
                            {{checkout_form.get("coupons.discount.why").value}}
                          </p>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>

              <ng-container *ngIf="alacarte_session.allowed_payment_methods.length > 1">
                <hr>
                <div class="payment-method mb-3">
                  <h5 class="mb-3">Payment Method</h5>
                  <ng-select placeholder="Select your payment method" formControlName="payment_method"
                    appearance="outline" [clearable]="false" [searchable]="false">
                    <ng-container *ngFor="let pm of alacarte_session.allowed_payment_methods">
                      <ng-container *ngIf="pm !== payment_methods.COUPON">
                        <ng-option [value]="pm" *ngIf="pm === payment_methods.CREDIT_CARD">
                          <img loading="lazy" src="assets/logos/mastercard.png" height="20" class="me-2">
                          <img loading="lazy" src="assets/logos/visa.png" height="14" class="me-2"> Credit
                          Card
                        </ng-option>
                        <ng-option [value]="pm" *ngIf="pm === payment_methods.PAYPAL">
                          <img loading="lazy" src="assets/logos/paypal.png" height="20" class="me-2"> Paypal
                        </ng-option>
                      </ng-container>
                    </ng-container>
                  </ng-select>
                </div>
              </ng-container>

              <hr>
              <div [hidden]="checkout_form.controls.payment_method.value !== payment_methods.CREDIT_CARD">
                <!-- Credit card -->
                <h5 class="mb-2">Card Details</h5>
                <div class="my-3">
                  <div class="collapse show mt-3">
                    <div id="card-element" #cardInfo>
                      <!-- Elements will create input elements here -->
                    </div>
                    <p class="input-error" *ngIf="cardNumberError">{{cardNumberError}}</p>
                  </div>
                </div>
              </div>

              <div [hidden]="checkout_form.controls.payment_method.value !== payment_methods.PAYPAL">
                <!-- TODO::: Paypal -->
                paypal not available at the moment
              </div>

              <label class="checkbox-terms mt-4">
                <span class="checkbox">
                  <input type="checkbox" [checked]="acknowledged" (change)="acknowledged = !acknowledged">
                  <svg>
                    <use xlink:href="#checkbox" class="checkbox"></use>
                  </svg>
                </span>
                <small>
                  By clicking here you agree to the brandqrcodes
                  <a routerLink="/terms" target="_blank">Terms of Service</a>, <a routerLink="/privacy-policy"
                    target="_blank">Privacy
                    Policy</a>.
                </small>
              </label>
              <button class="btn btn-success btn-block mt-4" (click)="startPayment()"
                [disabled]="!acknowledged || processing">
                <app-inline-loader _class="white" *ngIf="processing"></app-inline-loader>
                <span *ngIf="!processing">Confirm my order</span>
              </button>
              <p class="input-error" *ngIf="cardNumberError">{{cardNumberError}}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>

  </div>
</div>

<app-footer *ngIf="!alacarte_session?.cart.items.length">
  <a class="btn btn-secondary btn-lg mb-5" routerLink="/products/memories">
    <i class="bi bi-cart me-2"></i>
    Explore memories
  </a>
</app-footer>